import { getStaticOptions, localStorageTest, request } from "../utils";
import { getGlobalQueue } from ".";
import { locationRestJobsGet } from "../wp-api";
import { REMAINING_EVENT } from "../types";
/**
 * Allows to restore jobs from the local storage. This is helpful especially
 * when the jobs got locked by the server and could not be "restored the next time".
 */ const LOCAL_STORAGE_KEY_RESTORE_JOBS = "real-queue-restore-jobs";
/**
 * Fetch the next list of jobs so we can populate to our queue.
 */ async function restoreJobsFromLocalStorage(queueClass) {
    if (queueClass === void 0) queueClass = getGlobalQueue();
    if (localStorageTest()) {
        var _localStorage_getItem;
        const lsKey = `${LOCAL_STORAGE_KEY_RESTORE_JOBS}-${getStaticOptions().localStorageSuffix}`;
        const ids = (_localStorage_getItem = localStorage.getItem(lsKey)) == null ? void 0 : _localStorage_getItem.split(",").map(Number).filter(Boolean).join(",");
        localStorage.removeItem(lsKey);
        if (ids) {
            try {
                const { jobs, remaining } = await request({
                    location: locationRestJobsGet,
                    params: {
                        ids
                    }
                });
                const unfinished = jobs.filter((param)=>{
                    let { process, process_total, runs, retries, locked } = param;
                    return process < process_total && runs < retries + 1 && !locked;
                });
                queueClass.enqueueFromList(unfinished);
                getStaticOptions().remaining = remaining;
                document.dispatchEvent(new CustomEvent(REMAINING_EVENT, {
                    detail: {
                        remaining
                    }
                }));
                // Save back the "unfinished" jobs so dangling jobs are automatically removed
                localStorage.setItem(lsKey, unfinished.map((param)=>{
                    let { id } = param;
                    return id;
                }).join(","));
                return unfinished.length > 0;
            } catch (e) {
            // Silence is golden.
            }
        }
    }
    return false;
}
export { LOCAL_STORAGE_KEY_RESTORE_JOBS, restoreJobsFromLocalStorage };
